const VALID_STATUSES = ['Menunggu Respon', 'Diproses', 'Dikirim', 'Sampai'];

export const getEffectivePurchaseStatus = (pembelian = {}) => {
  const rawStatus = String(pembelian?.statusPengiriman || '').trim();
  if (VALID_STATUSES.includes(rawStatus)) {
    return rawStatus;
  }

  const detailItems = Array.isArray(pembelian?.DetailTransaksi)
    ? pembelian.DetailTransaksi
    : Array.isArray(pembelian?.items)
      ? pembelian.items
      : [];

  const hasShippedItems = detailItems.some((item) => item?.dikirim);
  if (hasShippedItems) {
    return 'Diproses';
  }

  const hasShippingActivity = Boolean(
    pembelian?.tanggalKirim ||
    pembelian?.tanggalSampai ||
    pembelian?.fotoPengiriman ||
    pembelian?.fotoSampai ||
    pembelian?.catatanPengiriman
  );

  if (hasShippingActivity) {
    return 'Dikirim';
  }

  return 'Menunggu Respon';
};
